import styled from 'styled-components';

const Dropdown = styled.div.attrs({
    className: 'tooltip-menu',
})`
    position: relative;
    display: flex;
    flex-direction: column;

    &:not(.active) {
        .dropdown-container {
            display: none;
        }
        .title > .icon-arrow-down {
            opacity: 0.8;
            transform: rotate(0);
        }
    }
    .title {
        font-weight: 600;
        font-size: 14px;
        line-height: 28px;
        display: flex;
        gap: 8px;
        align-items: center;
        cursor: pointer;
    }

    &.dropdown-100 .dropdown-container {
        min-width: 100%;
    }

    .dropdown-container {
        position: absolute;
        top: 130%;
        border-radius: 15px;
        z-index: 9;
        animation: 300ms tooltip-fade forwards;
        white-space: nowrap;
        background: white;
        overflow: hidden;
        border: 1.5px solid #e6e6e6;
        min-width: 205px;
        right: 0;

        li {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 17px 24px;
            box-sizing: border-box;
            border-bottom: 1.5px solid #e6e6e6;
            list-style: none;
            font-size: 16px;
            letter-spacing: 0.02em;
            cursor: pointer;
            transition: .3s all;

            &:last-of-type {
                background: #f8f8f8;
            }

            &:last-of-type {
                border-bottom: none;
                background: #fff;
            }

            &:hover {
                opacity: 0.7;
            }

            &:active {
                opacity: 0.4;
            }

            span {
                color: #0a0a0a;
                opacity: 0.4;
            }
        }
    }

    @keyframes tooltip-fade {
        0% {
            opacity: 0;
            top: 150%;
        }
        100% {
            opacity: 1;
            top: 130%;
        }
    }
`;

export default Dropdown;
